import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaPlus, FaEdit, FaTrash, FaDollarSign,
    FaCheckCircle, FaTimesCircle, FaArrowRight,
    FaSearch, FaFilter, FaCalendarAlt, FaChartLine
} from "react-icons/fa";

export default function UsdExchangeRatesPage() {
    const { backEnd_request } = BackMethods();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [rates, setRates] = useState([]);

    // حالات التصفية والبحث
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");

    // حالات المودال
    const [showModal, setShowModal] = useState(false);
    const [currentRate, setCurrentRate] = useState({
        rate: "",
        isActive: true,
        effectiveDateUtc: new Date().toISOString().slice(0, 16)
    });
    const [isEdit, setIsEdit] = useState(false);

    // تحميل أسعار الصرف
    const loadRates = async () => {
        setLoading(true);
        try {
            const response = await backEnd_request.get("/UsdExchangeRates");
            setRates(response.data);
        } catch (err) {
            console.error("خطأ في جلب البيانات", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadRates();
    }, []);

    // --- منطق الفلترة والبحث ---
    const filteredRates = rates.filter(item => {
        const matchesSearch = item.rate.toString().includes(searchTerm) ||
            new Date(item.effectiveDateUtc).toLocaleDateString('ar-EG').includes(searchTerm);

        const matchesStatus = statusFilter === "all" ? true :
            statusFilter === "active" ? item.isActive === true :
                item.isActive === false;

        return matchesSearch && matchesStatus;
    });

    // تغيير حالة التفعيل (نشط / متوقف)
    const handleToggleStatus = async (id) => {
        try {
            await backEnd_request.post(`/UsdExchangeRates/${id}/activate`);
            loadRates(); // إعادة تحميل البيانات لتحديث الحالة
        } catch (err) {
            alert("حدث خطأ أثناء تغيير الحالة");
        }
    };

    // const handleDelete = async (id) => {
    //     if (window.confirm("هل أنت متأكد من حذف هذا السعر؟")) {
    //         try {
    //             await backEnd_request.delete(`/UsdExchangeRates/${id}`);
    //             setRates(rates.filter(r => r.exchangeRateId !== id));
    //         } catch (err) {
    //             alert("حدث خطأ أثناء الحذف");
    //         }
    //     }
    // };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                rate: parseFloat(currentRate.rate),
                isActive: currentRate.isActive,
                effectiveDateUtc: new Date(currentRate.effectiveDateUtc).toISOString()
            };

            if (isEdit) {
                await backEnd_request.post(`/UsdExchangeRates/${currentRate.exchangeRateId}`, payload);
            } else {
                await backEnd_request.post("/UsdExchangeRates", payload);
            }
            setShowModal(false);
            loadRates();
            setCurrentRate({ rate: "", isActive: true, effectiveDateUtc: new Date().toISOString().slice(0, 16) });
        } catch (err) {
            alert("خطأ في حفظ البيانات");
        }
    };

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl">
            <div className="container shadow-sm bg-white rounded-4 p-4">

                {/* الرأس - Header */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 pb-3 border-bottom gap-3">
                    <div>
                        <h3 className="fw-bold text-success mb-1">
                            <FaDollarSign className="ms-2" /> إدارة سعر صرف الدولار
                        </h3>
                        <p className="text-muted small mb-0">إجمالي السجلات: {filteredRates.length}</p>
                    </div>
                    <div className="d-flex gap-2">
                        <button
                            onClick={() => {
                                setIsEdit(false);
                                setCurrentRate({ rate: "", isActive: true, effectiveDateUtc: new Date().toISOString().slice(0, 16) });
                                setShowModal(true);
                            }}
                            className="btn btn-success d-flex align-items-center px-4 rounded-pill shadow-sm"
                        >
                            <FaPlus className="ms-2" /> إضافة سعر جديد
                        </button>
                        <button onClick={() => navigate(-1)} className="btn btn-outline-secondary rounded-pill">
                            <FaArrowRight className="ms-1" /> رجوع
                        </button>
                    </div>
                </div>

                {/* قسم التصفية والبحث */}
                <div className="row g-3 mb-4 bg-light p-3 rounded-3 border">
                    <div className="col-md-8">
                        <div className="input-group border rounded-pill bg-white px-3 py-1">
                            <span className="input-group-text bg-transparent border-0 text-muted"><FaSearch /></span>
                            <input
                                type="text"
                                className="form-control border-0 bg-transparent shadow-none"
                                placeholder="ابحث بالسعر أو التاريخ..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="input-group border rounded-pill bg-white px-3 py-1">
                            <span className="input-group-text bg-transparent border-0 text-muted"><FaFilter /></span>
                            <select
                                className="form-select border-0 bg-transparent shadow-none"
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                            >
                                <option value="all">جميع الحالات</option>
                                <option value="active">نشط (الحالي)</option>
                                <option value="inactive">غير نشط (سابق)</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* عرض الجدول */}
                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-success"></div></div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover align-middle border-light">
                            <thead className="table-light">
                                <tr>
                                    <th className="py-3 border-0">سعر الصرف</th>
                                    <th className="py-3 border-0">التاريخ </th>
                                    <th className="py-3 border-0 text-center">الحالة</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRates.map((item) => (
                                    <tr key={item.exchangeRateId}>
                                        <td className="fw-bold text-dark py-3">
                                            <span className="text-success">{item.rate.toLocaleString()}</span> ل.س
                                        </td>
                                        <td>
                                            <div className="small text-muted">
                                                <FaCalendarAlt className="ms-1" />
                                                {new Date(item.effectiveDateUtc).toLocaleString('ar-EG')}
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <button
                                                onClick={() => handleToggleStatus(item.exchangeRateId)}
                                                className={`btn btn-sm rounded-pill px-3 border-0 ${item.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}
                                            >
                                                {item.isActive ? (
                                                    <><FaCheckCircle className="ms-1" /> نشط</>
                                                ) : (
                                                    <><FaTimesCircle className="ms-1" /> متوقف</>
                                                )}
                                            </button>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Modal - إضافة وتعديل سعر الصرف */}
            {showModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg rounded-4">
                            <div className="modal-header border-0 pt-4 px-4">
                                <h5 className="fw-bold">{isEdit ? "تعديل سعر الصرف" : "إضافة سعر صرف جديد"}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleSave}>
                                <div className="modal-body p-4">
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">مقدار سعر الصرف (لكل 100 دولار)</label>
                                        <div className="input-group">
                                            <input
                                                type="number" className="form-control rounded-3"
                                                placeholder="مثال: 150000"
                                                value={currentRate.rate}
                                                onChange={(e) => setCurrentRate({ ...currentRate, rate: e.target.value })}
                                                required
                                            />
                                            <span className="input-group-text bg-light">د.ع</span>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">تاريخ ووقت النفاذ</label>
                                        <input
                                            type="datetime-local"
                                            className="form-control rounded-3"
                                            value={currentRate.effectiveDateUtc}
                                            onChange={(e) => setCurrentRate({ ...currentRate, effectiveDateUtc: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="form-check form-switch mt-3">
                                        <input
                                            className="form-check-input" type="checkbox"
                                            checked={currentRate.isActive}
                                            onChange={(e) => setCurrentRate({ ...currentRate, isActive: e.target.checked })}
                                        />
                                        <label className="form-check-label fw-bold small">تفعيل هذا السعر كـ "سعر حالي"</label>
                                    </div>
                                </div>
                                <div className="modal-footer border-0 p-4 pt-0">
                                    <button type="button" className="btn btn-light rounded-3 px-4" onClick={() => setShowModal(false)}>إغلاق</button>
                                    <button type="submit" className="btn btn-success rounded-3 px-4">حفظ البيانات</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}